import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
  MenuItem,
} from "@mui/material";
import {
  RestoreFromTrashRounded,
  SaveRounded,
} from "@mui/icons-material";




// Minimal Markdown previewer (bold, italics, headings, code, lists, links)
function MarkdownPreview({ value }) {
  const html = useMemo(() => basicMarkdownToHtml(value || ""), [value]);
  return (
    <Box sx={{ "& h1,h2,h3": { mt: 1.5 }, "& pre": { p: 1, bgcolor: "action.hover", borderRadius: 1 } }}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

function basicMarkdownToHtml(md) {
  let s = md;
  s = s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  s = s.replace(/^### (.*$)/gim, '<h3>$1</h3>');
  s = s.replace(/^## (.*$)/gim, '<h2>$1</h2>');
  s = s.replace(/^# (.*$)/gim, '<h1>$1</h1>');
  s = s.replace(/\*\*(.*?)\*\*/gim, '<strong>$1</strong>');
  s = s.replace(/\*(.*?)\*/gim, '<em>$1</em>');
  s = s.replace(/`([^`]+)`/gim, '<code>$1</code>');
  s = s.replace(/^\s*[-*] (.*)$/gim, '<li>$1</li>');
  s = s.replace(/(<li>.*<\/li>\n?)+/gim, (m) => `<ul>${m}</ul>`);
  s = s.replace(/\[(.*?)\]\((https?:\/\/[^\s)]+)\)/gim, '<a href="$2" target="_blank" rel="noreferrer">$1<\/a>');
  s = s.replace(/\n$/gim, '<br/>');
  return s;
}

// ---------------------------------------------------------------------------
// Notes Panel (Markdown toggle)
// ---------------------------------------------------------------------------
export default function NotesPanel({ note, 
  onSave }) {
  const [edit, setEdit] = useState(note.body || "" );
  const [mode, setMode] = useState("preview"); // edit | preview

  useEffect(() => setEdit(note.body||"" ), [note.body]);


  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="h6">Notes</Typography>
        <TextField
          select size="small" value={mode} onChange={(e) => setMode(e.target.value)}
          label="Mode" sx={{ width: 180 }}
        >
          <MenuItem value="edit">Edit</MenuItem>
          <MenuItem value="preview">Preview</MenuItem>
        </TextField>
      </Stack>

      {mode === "edit" ? (
        <TextField
          multiline minRows={12} fullWidth value={edit}
          onChange={(e) => setEdit(e.target.value)} placeholder="Write notes in Markdown…"
        />
      ) : (
        <Card variant="outlined">
          <CardContent>
            <MarkdownPreview value={edit} />
          </CardContent>
        </Card>
      )}

      <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ mt: 2 }}>
        <Button startIcon={<RestoreFromTrashRounded />} onClick={() => setEdit("")}>Clear</Button>
        <Button startIcon={<SaveRounded />} variant="contained" onClick={() => onSave({body:edit})}>Save</Button>
      </Stack>
    </Box>
  );
}
